import React from "react";

const Type = () => {
    return (
        <p className="shine">Full Stack Developer</p>
      )
}

export default Type